import { FC, useCallback } from "react";
import { useSelector } from "react-redux";
import { EmptyMessage } from "src/components";
import { PdTableCellText } from "src/components/layout/table";
import { useFocusableQuery } from "src/hooks/api";
import { tColumn } from "src/hooks/table";
import api from "src/util/apiNew";
import { tProductInventoryReport } from "tmt_api/src/types/dtos";

import { PdSpinner, ReportTable } from "./components";
import { formatDate, getParams } from "./utils";

const getProductsInventoryReport = (start: Date, end: Date) =>
  api.get<tProductInventoryReport[]>("reports/products-inventory", getParams(start, end)).then((res) => res.data);

const columns: tColumn<tProductInventoryReport>[] = [
  {
    id: "dateUpdatedInSeconds",
    header: "Date Updated",
    accessor: (originalRow) => formatDate(originalRow.dateUpdatedInSeconds),
    Cell: ({ value }) => <PdTableCellText>{value}</PdTableCellText>,
    style: { width: 120 },
  },
  {
    id: "brandName",
    header: "Brand Name",
    accessor: (originalRow) => originalRow.brandName,
    Cell: ({ value }) => <PdTableCellText>{value}</PdTableCellText>,
    style: { width: 200 },
  },
  {
    id: "name",
    header: "Name",
    accessor: (originalRow) => originalRow.name,
    Cell: ({ value }) => <PdTableCellText>{value}</PdTableCellText>,
    style: { width: 260 },
  },
  {
    id: "inventory",
    header: "Inventory",
    accessor: (originalRow) => originalRow.inventory,
    Cell: ({ value }) => <PdTableCellText>{value}</PdTableCellText>,
    style: { width: 140 },
  },
];

const ProductsInventoryTable: FC<{ period: Date[] }> = ({ period }) => {
  const config = useSelector((state) => state.TableConfigReducer.productsInventoryReport);
  const { isLoading, data } = useFocusableQuery<tProductInventoryReport[]>(
    useCallback(() => getProductsInventoryReport(period[0], period[1]), [period]),
    { enabled: !!(period[0] && period[1]) },
  );

  if (isLoading) {
    return <PdSpinner />;
  }

  if (!data || data?.length === 0) {
    return <EmptyMessage message="There is no data to display" />;
  }

  return (
    <ReportTable
      data={data}
      columns={columns}
      keyExtractor={(item) => `${item.sku}-${item.name}`}
      sortedBy="dateUpdatedInSeconds"
      columnsConfig={config}
      tableConfigReduxKey="productsInventoryReport"
    />
  );
};

export default ProductsInventoryTable;
